module.exports = __webpack_public_path__ + "static/media/student_front.aeb4d18b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/studentPilot/student_front.png
// module id = 2265
// module chunks = 0